import './src/styles/global.css';
import './webview';

import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();
